import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {
  GradingPeriodDTO,
  IGradingPeriodDTO,
} from '@app/infrastructure/models/grading-period';
import { PillButtonDTO } from '@app/infrastructure/models/pill-button-dto';
import { IStudentListSortDTO } from '@app/infrastructure/models/student';

import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { months } from '@app/infrastructure/utils/constants';
import {
  ITeacherClassDetailDTO,
  TeacherClassDetailDTO,
} from '@app/infrastructure/models/teacher-classroom';

@Component({
  selector: 'app-pill-button-list',
  template: `<app-pill-button-list-presentation
    [pillButtonDTOList]="pillButtons"
    [gradingLink]="gradingLink"
    [hasEdit]="hasEdit"
    [classroom]="classroom"
    (selectionEvent)="propagateSelectionEvent($event)"
    (editEvent)="editPill($event)"
  >
  </app-pill-button-list-presentation>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PillButtonListSmartComponent implements OnInit {
  @Input() gradingPeriods: IGradingPeriodDTO[];
  @Input() gradingLink: string;
  @Input() public classroom: ITeacherClassDetailDTO =
    new TeacherClassDetailDTO();
  @Output() selectionEvent: EventEmitter<IStudentListSortDTO> =
    new EventEmitter<IStudentListSortDTO>();
  @Output() editEvent: EventEmitter<void> = new EventEmitter<void>();
  @Input() activeId: string = '';
  @Input() hasEdit: boolean;

  pillButtons: PillButtonDTO[];

  constructor() {}

  ngOnInit(): void {
    this.pillButtons = this.getPillButtons();
  }

  // TODO for propagate Grading Periods with Units
  propagateSelectionEvent(value: PillButtonDTO) {
    // Transform PillButtonDTO selection into IStudentLIstSortDTO
    const sort: IStudentListSortDTO = {
      gradingPeriodId: '',
      classroomId: '',
    };

    if (value.payload) {
      const payload: GradingPeriodDTO = value.payload;
      sort.gradingPeriodId = payload.id.toString();
      sort.classroomId = payload.classroomId;
    }

    // Bubble up . ◦°
    this.selectionEvent.emit(sort);
  }

  editPill(event) {
    this.editEvent.emit();
  }

  getPillButtons(): PillButtonDTO[] {
    if (!this.gradingPeriods) {
      const pills: PillButtonDTO[] = [];
      pills.push(
        new PillButtonDTO('0', 'Current Era', '0 C.E. -Present', true),
      );
      return pills;
    }

    return this.gradingPeriods.map((value, index) => {
      return this.buildPill(value, this.activeId ? false : true);
    });
  }

  buildPill(
    item: IGradingPeriodDTO,
    gradingFlag: boolean = false,
  ): PillButtonDTO {
    const payload = item;
    const title = item.gradingPeriodTitle;
    let subtitle = item.fromDate + '-' + item.toDate;
    let isSelected: boolean;
    if (gradingFlag) {
      isSelected = false;
    } else {
      isSelected = this.isDateWithinRange(
        new Date(item.fromDate),
        new Date(item.toDate),
        new Date(),
      );
    }

    subtitle = `${this.getMonthFormattedDate(
      new Date(item.fromDate),
    )} - ${this.getMonthFormattedDate(new Date(item.toDate))}`;
    return new PillButtonDTO(item.id, title, subtitle, isSelected, payload);
  }

  isDateWithinRange(from: Date, to: Date, check: Date): boolean {
    return check.getTime() > from.getTime() && check.getTime() < to.getTime();
  }

  getMonthFormattedDate(date: Date): string {
    const formattedDate =
      this.getAbbreviatedMonth(date) +
      ' ' +
      date.getDate() +
      ', ' +
      date.getFullYear();
    return formattedDate;
  }

  getAbbreviatedMonth(date: Date): string {
    return months[date.getMonth()];
  }
}
